import styled, { css } from 'styled-components'
import FlexRow from '@/ui/FlexRow'
import Icon from '@/ui/Icon'

export const FileName = styled.div`
  padding: 0 1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const FileLabel = styled.label`
  ${({ theme: { primaryColor, secondaryColor } }) => css`
    &&&&& {
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      max-width: 100%;
      .button:hover {
        background-color: ${primaryColor} !important;
        color: ${secondaryColor} !important;
      }
    }
  `}
`

export const AcceptedFileTypesLabel = styled.div`
  display: inline-block;
  font-size: 12px;
  font-style: italic;
  margin-top: 4px;
  cursor: pointer;
`

export const AcceptedFileTypes = styled.ul`
  max-height: 200px;
  overflow: auto;

  li {
    margin: 0;
  }
`

export const FileUploadWrapper = styled(FlexRow).attrs({
  noMargin: true,
  justifyContent: 'flex-start',
  alignItems: 'center',
})`
  &&& {
    white-space: nowrap;
    max-width: 100%;

    button {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    > div:first-child {
      display: inline-flex;
      align-items: center;
      border: 1px solid #cecece;
      max-width: 100%;

      .button {
        display: inline-flex !important;
        border: 0;
        border-right: 1px solid #cecece;
      }

      input[type='file'] {
        display: none !important;
      }
    }
  }
`

export const ClearIcon = styled(Icon).attrs({
  button: true,
  name: 'icon-trash',
  color: 'gray',
})`
  margin-left: 0.5em !important;

  :hover {
    color: red !important;
  }
`
